module.exports = __webpack_public_path__ + "assets/img/18_172_big.5608975b.jpg";